// @ts-nocheck
import moment from 'moment';

export const trackerPathWithLogs = (trackerPaths: any[], trackerLogs: Array<any[]>) => {
  const paths = trackerPaths.map((path: any, i: number) => ({
    ...path,
    tracker_logs: trackerLogs[i].sort((a: any, b: any) => {
      const timestampA: any = a.properties.timestamp;
      const timestampB: any = b.properties.timestamp;
      return moment(timestampB) - moment(timestampA);
    }),
  }));
  return paths;
};

export const onboardingTrackerPaths: any = [
  {
    id: 554,
    timestamp_start: '2022-11-08T12:14:15',
    timestamp_stop: '2022-11-08T19:38:55',
    soc_start: null,
    soc_stop: null,
    rk_start: null,
    rk_stop: null,
    odometer_start: null,
    odometer_stop: null,
    virtual_odometer_start: null,
    virtual_odometer_stop: null,
    soh: null,
    co2_avoided: null,
    vehicle: 'RRZC69',
    station_start: 13,
    station_stop: 13,
  },
  {
    id: 553,
    timestamp_start: '2022-11-07T13:22:41',
    timestamp_stop: '2022-11-07T20:34:47',
    soc_start: null,
    soc_stop: null,
    rk_start: null,
    rk_stop: null,
    odometer_start: null,
    odometer_stop: null,
    virtual_odometer_start: null,
    virtual_odometer_stop: null,
    soh: null,
    co2_avoided: null,
    vehicle: 'RRZC69',
    station_start: 4,
    station_stop: 13,
  },
  {
    id: 552,
    timestamp_start: '2022-11-04T13:43:42',
    timestamp_stop: '2022-11-07T13:01:49',
    soc_start: null,
    soc_stop: null,
    rk_start: null,
    rk_stop: null,
    odometer_start: null,
    odometer_stop: null,
    virtual_odometer_start: null,
    virtual_odometer_stop: null,
    soh: null,
    co2_avoided: null,
    vehicle: 'RRZC69',
    station_start: 4,
    station_stop: 4,
  },
  {
    id: 551,
    timestamp_start: '2022-11-04T11:06:20',
    timestamp_stop: '2022-11-04T13:08:11',
    soc_start: null,
    soc_stop: null,
    rk_start: null,
    rk_stop: null,
    odometer_start: null,
    odometer_stop: null,
    virtual_odometer_start: null,
    virtual_odometer_stop: null,
    soh: null,
    co2_avoided: null,
    vehicle: 'RRZC69',
    station_start: 13,
    station_stop: 4,
  },
  {
    id: 550,
    timestamp_start: '2022-11-02T20:10:35',
    timestamp_stop: '2022-11-03T19:48:08',
    soc_start: null,
    soc_stop: null,
    rk_start: null,
    rk_stop: null,
    odometer_start: null,
    odometer_stop: null,
    virtual_odometer_start: null,
    virtual_odometer_stop: null,
    soh: null,
    co2_avoided: null,
    vehicle: 'RRZC69',
    station_start: 13,
    station_stop: 13,
  },
];
